import { useState } from 'react';

export function useWaveformParams() {
  const [waveformWindowMs, setWaveformWindowMs] = useState(20);
  const [waveformFps, setWaveformFps] = useState(30);
  const [waveformGrid, setWaveformGrid] = useState(true);
  const [waveformHoriz, setWaveformHoriz] = useState(4);
  const [waveformVert, setWaveformVert] = useState(8);
  return {
    waveformWindowMs, setWaveformWindowMs,
    waveformFps, setWaveformFps,
    waveformGrid, setWaveformGrid,
    waveformHoriz, setWaveformHoriz,
    waveformVert, setWaveformVert,
  };
}
